import * as React from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { Redirect } from "react-router";
import axios from "../../helpers/axios";
import { formatDate } from "../../helpers/custom";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  Modal,
  InputLabel,
  IconButton,
  TextField,
  Divider,
  Box,
  Backdrop,
  CircularProgress,
  ButtonGroup,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Tooltip,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatTime } from "../../helpers/custom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { withTranslation, WithTranslation } from "react-i18next";
import { CloseOutlined } from "@mui/icons-material";
import DiversionHeader from "./DiversionHeader";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import newURL from "../../helpers/newUrl";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Legend);


const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  p: 4,
};

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
  showLoader: boolean;
  materialFlowDuration: string;
  diversionPerformanceDuration: string;
  wasteType: string;
  incomingWasteDataBar: any;
  incomingWasteBarChartOptions: any;
  divertedWasteDataBar: any;
  divertedWasteBarChartOptions: any;
  outgoingWasteDataBar: any;
  outgoingWasteBarChartOptions: any;
  diversionPerformanceDataBar: any;
  diversionPerformanceBarChartOptions: any;
  inventoryInHandDataBar: any;
  inventoryInHandBarChartOptions: any;
  showExportExpenses: boolean;
  fromDate?: string | null;
  toDate?: string | null;
  showCustomDateFilter: boolean;
  customFromDate?: string | null;
  customToDate?: string | null;
  durationType: string;
  routes: any[];
  routesRaw: any[];
  sources: any[];
  inventoryTotal: number;
  inventoryData: any;
  sorting_agents: any[];
  material_types: any;
  material_types_raw: any;
  showAddIncomingWasteByVehicle: boolean;
  showAddIncomingWasteByMassUpload: boolean;
  showAddDivertedWasteByMassUpload: boolean;
  /**Add waste by Vehicle Form Data */
  route_id?: any;
  source?: string;
  time: null;
  datetime?: string | null;
  vehicle?: any;
  vehicle_capacity?: any;
  percent_full?: number;
  total_waste?: number;
  recyclables_percentage?: number;
  recyclables_kg?: number;
  organics_percentage?: number;
  organics_kg?: number;
  residual_percentage?: number;
  residual_kg?: number;
  material_type?: any;
  raw_material_in_kg?: number;
  massUploadData?: any;
  /**Add waste by Vehicle Form Data */
  units: any[];
  hideAddIncomingWasteByVehicleBtn: boolean;
  showAddWasteByVehicle: boolean;
  editVehicle: boolean;
  editUUID: string;
  date?: string | null;
  agents: any;
  vehicles: any[];
  vehiclesMapped: any;
  agent_id: any;
  container: any;
  hangar: any;
  vehicle_density: any;
  total_incoming_waste_percentage: any;
  total_incoming_waste_kg: any;
  total_hangar_percentage: any;
  total_hangar_waste_kg: any;
  total_container_percentage: any;
  total_container_waste_kg: any;
  total_incoming_waste_volume: number;
  total_hangar_waste_volume: number;
  total_container_volume: number;
  depatureTime: any;
  arrivalTime: any;
  depatureKM: number;
  arrivalKM: number;
  outgoing: number;
  incoming: number;
  sorted: number;
  unsorted: number;
  vehicleDensityMapped: any;
  materialTypes: any;
  pageSize: any;
  error: boolean;
  errorMessage: string;
  showAddByVehicleSubmitButton: boolean;
  vehiclDriverError: boolean;
  vehicleFleetIdError: boolean;
  vehicleScheduleError: boolean;
  vehicleClusterError: boolean;
  vehicleIncomingWasteError: boolean;
  vehicleHangarError: boolean;
  vehicleContainerError: boolean;
  vehicleDateTimeError: boolean;
  ValueWrongError: boolean;
  ValueWrongErrorMsg: string;
  showWeightReportGraph: boolean;
  weightReportDataBar: any;
  weightReportBarChartOptions: any;
  selectedWasteType: string;
  selectedDateFilter: string;
  reject: number;
  dailyAnalyticsData: Array<{
    date: string;
    incoming: number;
    sorted: number;
    reject: number;
    outgoing: number;
    outgoingValueINR: number;
    inventoryTotal?: number;
    inventoryData?: any;
  }>;
}

class Diversion extends React.Component<
  RouteComponentProps & IProps & WithTranslation,
  IState
> {
  constructor(props: RouteComponentProps & IProps & WithTranslation) {
    super(props);
    this.state = {
      showLoader: false,
      materialFlowDuration: "month",
      diversionPerformanceDuration: "month",
      wasteType: "",
      incomingWasteDataBar: {
        labels: [],
        datasets: [],
      },
      // incomingWasteDataBar: {},
      incomingWasteBarChartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top" as const,
            rotate: "90",
          },
          title: {
            display: true,
            text: "Incoming Waste",
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
          y: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
        },
      },
      divertedWasteDataBar: {
        labels: [],
        datasets: [
          {
            label: "Organic",
            data: [],
            backgroundColor: "rgba(58, 87, 138, 1)",
            // borderWidth: 2,
            // borderColor: 'rgba(58, 87, 138, 1)'
          },
          {
            label: "Recyclable",
            data: [],
            backgroundColor: "rgba(71, 50, 123, 1)",
            // borderWidth: 2,
            // borderColor: 'rgba(71, 50, 123, 1)'
          },
        ],
      },
      divertedWasteBarChartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top" as const,
          },
          title: {
            display: true,
            text: "Diverted Waste",
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
          y: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
        },
      },
      outgoingWasteDataBar: {
        labels: [],
        datasets: [
          {
            label: "Organic",
            data: [],
            backgroundColor: "rgba(58, 87, 138, 1)",
            // borderWidth: 2,
            // borderColor: 'rgba(58, 87, 138, 1)'
          },
          {
            label: "Recyclable",
            data: [],
            backgroundColor: "rgba(71, 50, 123, 1)",
            // borderWidth: 2,
            // borderColor: 'rgba(71, 50, 123, 1)'
          },
        ],
      },
      outgoingWasteBarChartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top" as const,
          },
          title: {
            display: true,
            text: "Outgoing Waste",
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
          y: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
        },
      },
      diversionPerformanceDataBar: {
        labels: [],
        datasets: [
          {
            label: "Diverted Waste",
            data: [],
            backgroundColor: "rgba(58, 87, 138, 1)",
            // borderWidth: 2,
            // borderColor: 'rgba(58, 87, 138, 1)'
          },
        ],
      },
      diversionPerformanceBarChartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top" as const,
          },
          title: {
            display: true,
            text: "Diversion % of Sorted/ Incoming Waste",
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
          y: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
        },
      },
      inventoryInHandDataBar: {
        labels: [],
        datasets: [
          {
            label: "Diversion Today",
            data: [],
            // backgroundColor: 'rgba(0, 176, 172, 1)',
            backgroundColor: "rgba(32, 77, 54, 1)",
            // borderWidth: 2,
            // borderColor: 'rgba(0, 176, 172, 1)'
          },
        ],
      },
      inventoryInHandBarChartOptions: {
        indexAxis: "y" as const,
        responsive: true,
        plugins: {
          legend: {
            display: false,
            position: "bottom" as const,
          },
          title: {
            display: true,
            text: "Diversion Material in kg",
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
          y: {
            stacked: true,
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
        },
      },
      /*inventoryInHandDataBar: {
                labels: ["Material Type"],
                datasets: [
                    {
                        label: 'Gelas/sok dengan label belum dilepas atau kotor (PP)',
                        data: [10],
                        backgroundColor: 'rgba(42, 136, 141, 0.8)',
                        borderWidth: 2,
                        borderColor: 'rgba(42, 136, 141, 1)'
                    },
                    {
                        label: 'Diverted Waste',
                        data: [14],
                        backgroundColor: 'rgba(44, 167, 132, 0.8)',
                        borderWidth: 2,
                        borderColor: 'rgba(44, 167, 132, 1)'
                    },
                    {
                        label: 'Diverted Waste',
                        data: [16],
                        backgroundColor: 'rgba(52, 105, 140, 0.8)',
                        borderWidth: 2,
                        borderColor: 'rgba(52, 105, 140, 1)'
                    }
                ]
            },
            inventoryInHandBarChartOptions: {
                indexAxis: 'y' as const,
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top' as const,
                    },
                    title: {
                        display: true,
                        text: 'Diversion Material in kg',
                    },
                },
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                    },
                }
            },*/
      showExportExpenses: false,
      fromDate: null,
      toDate: null,
      showCustomDateFilter: false,
      customFromDate: null,
      customToDate: null,
      durationType: "",
      routes: [],
      routesRaw: [],
      sources: [],
      time: formatDate(
        formatDate(new Date(), "Y-m-d") + " 00:00:00",
        "Y-m-d H:i:s"
      ),
      vehicles: [],
      sorting_agents: [],
      selectedWasteType: "incoming",
      material_types: [],
      material_types_raw: {},
      showAddIncomingWasteByVehicle: false,
      showAddIncomingWasteByMassUpload: false,
      showAddDivertedWasteByMassUpload: false,
      route_id: "",
      source: "",
      datetime: null,
      vehicle: "",
      total_waste: 0,
      outgoing: 0,
      incoming: 0,
      sorted: 0,
      unsorted: 0,
      material_type: "",
      massUploadData: {},
      units: [],
      showAddWasteByVehicle: false,
      selectedDateFilter: "month", // default value
      agents: [],
      date: null,
      materialTypes: [],
      inventoryTotal: 0,
      inventoryData: "",
      hideAddIncomingWasteByVehicleBtn: true,
      agent_id: "",
      container: 0,
      hangar: 0,
      vehicle_density: 0,
      total_incoming_waste_percentage: 0,
      total_incoming_waste_kg: 0,
      total_hangar_percentage: 0,
      total_hangar_waste_kg: 0,
      total_container_percentage: 0,
      total_container_waste_kg: 0,
      total_incoming_waste_volume: 0,
      total_hangar_waste_volume: 0,
      total_container_volume: 0,
      depatureTime: "",
      depatureKM: 0,
      arrivalKM: 0,
      arrivalTime: "",
      editVehicle: false,
      editUUID: "",
      vehiclesMapped: {},
      vehicleDensityMapped: {},
      pageSize: 20,
      error: true,
      errorMessage: "",
      showAddByVehicleSubmitButton: true,
      vehicleDateTimeError: true,
      vehiclDriverError: true,
      vehicleFleetIdError: true,
      vehicleScheduleError: true,
      vehicleClusterError: true,
      dailyAnalyticsData: [],
      reject: 0,
      vehicleIncomingWasteError: true,
      vehicleHangarError: true,
      vehicleContainerError: true,
      ValueWrongError: true,
      ValueWrongErrorMsg: "",
      showWeightReportGraph: true,
      // weightReportDataBar: {
      //     labels: (() => {
      //         const today = new Date();
      //         const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
      //         return Array.from({ length: daysInMonth }, (_, i) => {
      //             const d = new Date(today.getFullYear(), today.getMonth(), i + 1);
      //             return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      //         });
      //     })(),
      //     datasets: []
      // },
      weightReportDataBar: {
        // labels: Array.from({ length: 30 }, (_, i) => `Apr ${i + 1}`),
        labels: Array.from(
          {
            length: new Date(
              new Date().getFullYear(),
              new Date().getMonth() + 1,
              0
            ).getDate(),
          },
          (_, i) =>
            `${new Date().toLocaleString("en-US", { month: "short" })} ${i + 1}`
        ),
        datasets: [
          {
            label: "kg",
            data: [],
            // backgroundColor: 'rgba(0, 176, 172, 1)',
            backgroundColor: "rgba(32, 77, 54, 0.5)",
            borderWidth: 2,
            borderColor: "rgba(32, 77, 54, 1)",
          },
        ],
      },
      weightReportBarChartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom" as const,
          },
          title: {
            display: false,
            // text: 'Waste Collected',
          },
          datalabels: { display: false }, 
        },
        scales: {
          x: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
          y: {
            grid: {
              display: true,
              color: "#F8F8F8",
            },
          },
        },
      },
    };
  }
  public componentDidMount(): void {
    // axios.get(`curation-stats`).then(response => {
    //     this.setState({ curation_stats: response.data.data })
    // });
    this.forceUpdate();
    this.fetchMaterialFlowReporting();
    this.fetchDiversionPerformance();
    this.fetchInventoryInHand();
    this.fetchRoutes();
    this.fetchSources();
    this.fetchVehicles();
    this.fetchVehiclesAll();
    this.fetchAgentsAll();
    this.fetchAgents();
    this.fetchMaterialTypes();
    this.fetchMaterialTypesAll();
    this.fetchUnits();
    this.hideButtons();
    this.fetchWasteAnalytics();
    this.fetchWasteAnalyticsTableData();
    this.fetchInventory();
  }
  public fetchInventory() {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let params = { hierarchies: this.props.user.selectedHierarchyIds };
      newURL
        .get(`inventory`, { params })
        .then((response) => {
          if (response.data) {
            const data = response.data;
            this.setState({
              inventoryTotal: data.total, // total inventory weight
              inventoryData: data, // you can store full data if needed
              showLoader: false,
            });
          }
        })
        .catch(() => {
          this.setState({ showLoader: false });
        });
    }
  }
  public fetchMaterialFlowReporting(
    filter: string = this.state.materialFlowDuration,
    subfilter: string = this.state.wasteType
  ) {
    // if (this.props.user.selectedHierarchyIds.length) {
    this.setState({ showLoader: false });
    let body: any = {
      hierarchies: this.props.user.selectedHierarchyIds,
    };
    if (filter == "custom") {
      body.start_date = this.state.customFromDate
        ? formatDate(this.state.customFromDate, "Y-m-d")
        : "";
      body.end_date = this.state.customToDate
        ? formatDate(this.state.customToDate, "Y-m-d")
        : "";
    } else {
      body.filter = filter;
    }
    if (subfilter) {
      body.subfilter = subfilter;
    }
    axios
      .post(`homeReport`, body)
      .then((response: any) => {
        if (response.data.success) {
          let data: any = response.data.data;
          let incomingWasteDataBar = this.state.incomingWasteDataBar;
          let backgroundColorArray = [
            "rgba(89, 251, 2, 0.5)",
            "rgba(77, 175, 193, 0.5)",
            "rgba(78, 17, 107, 0.5)",
            "rgba(234, 176, 44, 0.5)",
          ];
          incomingWasteDataBar.labels = data.label;
          incomingWasteDataBar.datasets = data?.datasets?.map(
            (dataset: any, i: any) => ({
              ...dataset,
              backgroundColor: backgroundColorArray[i],
            })
          );
          console.log("data", incomingWasteDataBar);
          this.setState({
            showLoader: false,
            incomingWasteDataBar: { ...incomingWasteDataBar },
            showCustomDateFilter: false,
          });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ showLoader: false });
      });
    // }
  }
  public fetchWasteAnalyticsTableData = async () => {
    if (!this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: false });
      return;
    }

    const { selectedDateFilter, customFromDate, customToDate } = this.state;
    const requestBody = { hierarchies: this.props.user.selectedHierarchyIds };

    let startDate: Date;
    let endDate: Date = new Date();

    if (selectedDateFilter === "custom") {
      startDate = new Date(customFromDate as string);
      endDate = new Date(customToDate as string);
    } else {
      const today = new Date();
      switch (selectedDateFilter) {
        case "today":
          startDate = today;
          break;
        case "week":
          startDate = new Date(today);
          startDate.setDate(today.getDate() - 6);
          break;
        case "month":
          startDate = new Date(today.getFullYear(), today.getMonth(), 1);
          endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          break;
        case "lastMonth":
          startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          endDate = new Date(today.getFullYear(), today.getMonth(), 0);
          break;
        default:
          startDate = today;
      }
    }

    this.setState({ showLoader: true });

    try {
      const response = await newURL.post("wasteallanalytics", requestBody, {
        params: {
          startDate: formatDate(startDate, "Y-m-d"),
          endDate: formatDate(endDate, "Y-m-d"),
        },
        headers: { "Content-Type": "application/json" },
      });

      const data = response.data;

      // Map API response data to the dailyAnalyticsData state array
      // const labels = data.graph?.incoming?.labels || [];
      // const incomingData = data.graph?.incoming?.data || [];
      // const sortedData = data.graph?.sorted?.data || [];
      // const rejectData = data.graph?.reject?.data || [];
      // const outgoingData = data.graph?.outgoing?.data || [];
      // const outgoingValueData = data.graph?.outgoing?.price || [];

      // const dailyAnalyticsData = labels.map((dateStr: string, index: number) => ({
      // date: (() => {
      //     if (/^\d{4}-\d{2}$/.test(dateStr)) {
      //         // Format YYYY-MM → Month Year
      //         const [year, month] = dateStr.split("-");
      //         const monthName = new Date(Number(year), Number(month) - 1).toLocaleString("en-US", { month: "short" });
      //         return `${monthName} ${year}`;
      //     } else {
      //         const d = new Date(dateStr);
      //         const day = d.getDate().toString().padStart(2, "0");
      //         const month = d.toLocaleString("en-US", { month: "short" });
      //         const year = d.getFullYear();
      //         return `${day}-${month}-${year}`;
      //     }
      //     })(),
      // incoming: incomingData[index] || 0,
      // sorted: sortedData[index] || 0,
      // reject: rejectData[index] || 0,
      // outgoing: outgoingData[index] || 0,
      // outgoingValueINR: outgoingValueData[index] || 0,
      // }));
      const incomingLabels = data.graph?.incoming?.labels || [];
      const sortedLabels = data.graph?.sorted?.labels || [];
      const rejectLabels = data.graph?.reject?.labels || [];
      const outgoingLabels = data.graph?.outgoing?.labels || [];

      const incomingData = data.graph?.incoming?.data || [];
      const sortedData = data.graph?.sorted?.data || [];
      const rejectData = data.graph?.reject?.data || [];
      const outgoingData = data.graph?.outgoing?.data || [];
      const outgoingValueData = data.graph?.outgoing?.price || [];

      // Build union of all labels
      const allLabels = Array.from(
        new Set([
          ...incomingLabels,
          ...sortedLabels,
          ...rejectLabels,
          ...outgoingLabels,
        ])
      ).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

      // Map over union labels
      const dailyAnalyticsData = allLabels.map((dateStr: string) => {
        const idxIncoming = incomingLabels.indexOf(dateStr);
        const idxSorted = sortedLabels.indexOf(dateStr);
        const idxReject = rejectLabels.indexOf(dateStr);
        const idxOutgoing = outgoingLabels.indexOf(dateStr);

        // Format date nicely
        let formattedDate: string;
        if (/^\d{4}-\d{2}$/.test(dateStr)) {
          // YYYY-MM → Month Year
          const [year, month] = dateStr.split("-");
          const monthName = new Date(
            Number(year),
            Number(month) - 1
          ).toLocaleString("en-US", { month: "short" });
          formattedDate = `${monthName} ${year}`;
        } else {
          const d = new Date(dateStr);
          const day = d.getDate().toString().padStart(2, "0");
          const month = d.toLocaleString("en-US", { month: "short" });
          const year = d.getFullYear();
          formattedDate = `${day}-${month}-${year}`;
        }

        return {
          date: formattedDate,
          incoming: idxIncoming >= 0 ? incomingData[idxIncoming] : 0,
          sorted: idxSorted >= 0 ? sortedData[idxSorted] : 0,
          reject: idxReject >= 0 ? rejectData[idxReject] : 0,
          outgoing: idxOutgoing >= 0 ? outgoingData[idxOutgoing] : 0,
          outgoingValueINR:
            idxOutgoing >= 0 ? outgoingValueData[idxOutgoing] : 0,
        };
      });

      // Aggregate totals if needed
      const incomingTotal = dailyAnalyticsData.reduce(
        (acc: any, val: any) => acc + val.incoming,
        0
      );
      const sortedTotal = dailyAnalyticsData.reduce(
        (acc: any, val: any) => acc + val.sorted,
        0
      );
      const rejectTotal = dailyAnalyticsData.reduce(
        (acc: any, val: any) => acc + val.reject,
        0
      );
      const outgoingTotal = dailyAnalyticsData.reduce(
        (acc: any, val: any) => acc + val.outgoing,
        0
      );

      this.setState({
        dailyAnalyticsData,
        incoming: incomingTotal,
        sorted: sortedTotal,
        reject: rejectTotal,
        outgoing: outgoingTotal,
        showLoader: false,
      });
    } catch (error) {
      console.error("Error fetching waste analytics table data:", error);
      this.setState({ showLoader: false });
    }
  };
  public fetchVehiclesAll() {
    axios
      .get(`getListOfVehicles`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let vehicleMapped: any = {};
        let data: any = response.data.data;
        console.log(data);
        for (const obj of data) {
          vehicleMapped[obj.id] = obj.capacity;
        }

        this.setState({ vehicles: data, vehiclesMapped: vehicleMapped });
      });
  }

  public createALocalTimeString(
    date: any,
    arrivalTimeHour: any,
    arrivalTimeMinutes: any
  ) {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDay(),
      arrivalTimeHour,
      arrivalTimeMinutes
    ).toLocaleTimeString();
  }

  public fetchDiversionPerformance(
    filter: string = this.state.diversionPerformanceDuration
  ) {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: false });
      let data: any = {
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      if (filter == "custom") {
        data.start_date = this.state.customFromDate
          ? formatDate(this.state.customFromDate, "Y-m-d")
          : "";
        data.end_date = this.state.customToDate
          ? formatDate(this.state.customToDate, "Y-m-d")
          : "";
      } else {
        data.filter = filter;
      }
      axios
        .post(`diversionTrackingReport`, data)
        .then((response: any) => {
          if (response.data.success) {
            let data: any = response.data.data;
            let diversionPerformanceDataBar =
              this.state.diversionPerformanceDataBar;
            if (filter == "today") {
              diversionPerformanceDataBar.labels = [
                formatDate(data.date.date, "d/m/Y"),
              ];
              diversionPerformanceDataBar.datasets[0].data = data.data;
            } else if (filter == "week") {
              diversionPerformanceDataBar.labels = data.dates;
              diversionPerformanceDataBar.datasets[0].data = data.data;
            } else if (filter == "month") {
              diversionPerformanceDataBar.labels = data.dates;
              diversionPerformanceDataBar.datasets[0].data = data.data;
            } else {
              diversionPerformanceDataBar.labels = data.dates;
              diversionPerformanceDataBar.datasets[0].data = data.data;
            }
            this.setState({
              showLoader: false,
              diversionPerformanceDataBar: diversionPerformanceDataBar,
              showCustomDateFilter: false,
            });
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ showLoader: false });
        });
    }
  }

  public fetchInventoryInHand() {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: false });
      let data = {
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      axios
        .post(`inventoryReport`, data)
        .then((response: any) => {
          if (response.data.success) {
            let data: any = response.data.data;
            let inventoryInHandDataBar = this.state.inventoryInHandDataBar;
            inventoryInHandDataBar.labels = data.labels;
            inventoryInHandDataBar.datasets[0].data = data.data;
            this.setState({
              showLoader: false,
              inventoryInHandDataBar: inventoryInHandDataBar,
            });
          } else {
            this.setState({ showLoader: false });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ showLoader: false });
        });
    }
  }

  public fetchRoutes() {
    axios
      .get(`allCommunitiesWithHierarchyLite`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let data: any = response.data.data;
        let routes: any = [];
        let hierarchies: any = [];
        data.map((route: any) => {
          if (!hierarchies[route.hierarchy_id]) {
            hierarchies[route.hierarchy_id] = {
              id: route.hierarchy_id,
              name: route.hierarchy_name,
              routes: [],
            };
            hierarchies[route.hierarchy_id].routes.push({
              type: "route",
              id: route.id,
              route: route.name,
              hierarchy_id: route.hierarchy_id,
              hierarchy_name: route.hierarchy_name,
            });
          } else {
            hierarchies[route.hierarchy_id].routes.push({
              type: "route",
              id: route.id,
              route: route.name,
              hierarchy_id: route.hierarchy_id,
              hierarchy_name: route.hierarchy_name,
            });
          }
        });
        hierarchies.map((hierarchy: any) => {
          routes.push({
            type: "hierarchy",
            id: "all",
            route: hierarchy.name,
            hierarchy_id: hierarchy.id,
            hierarchy_name: hierarchy.name,
          });
          routes.push({
            type: "multiple_routes",
            id: "all",
            route: "Multiple Routes",
            hierarchy_id: hierarchy.id,
            hierarchy_name: hierarchy.name,
          });
          hierarchy.routes.map((route: any) => {
            routes.push({
              type: "route",
              id: route.id,
              route: route.route,
              hierarchy_id: route.hierarchy_id,
              hierarchy_name: route.hierarchy_name,
            });
          });
        });
        this.setState({ routes: routes, routesRaw: data });
      });
  }

  public fetchSources() {
    axios
      .get(`getSourceOfIncomingWaste`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let data: any = response.data.data;
        this.setState({ sources: data });
      });
  }
  public fetchWasteAnalytics = async () => {
    if (!this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: false });
      return;
    }
    const {
      selectedWasteType,
      selectedDateFilter,
      customFromDate,
      customToDate,
    } = this.state;
    const queryParams: any = { type: selectedWasteType };
    const requestBody = { hierarchies: this.props.user.selectedHierarchyIds };
    let startDate: Date;
    let endDate: Date = new Date();
    if (selectedDateFilter === "custom") {
      startDate = new Date(customFromDate as string);
      endDate = new Date(customToDate as string);
      queryParams.startDate = formatDate(customFromDate, "Y-m-d");
      queryParams.endDate = formatDate(customToDate, "Y-m-d");
    } else {
      const today = new Date();
      switch (selectedDateFilter) {
        case "today":
          startDate = today;
          break;
        case "week":
          startDate = new Date(today);
          startDate.setDate(today.getDate() - 6);
          break;
        case "month":
          startDate = new Date(today.getFullYear(), today.getMonth(), 1);
          endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          break;
        case "lastMonth":
          startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          endDate = new Date(today.getFullYear(), today.getMonth(), 0);
          break;
        default:
          startDate = today;
      }
      queryParams.startDate = formatDate(startDate, "Y-m-d");
      queryParams.endDate = formatDate(endDate, "Y-m-d");
    }
    this.setState({ showLoader: true });
    try {
      const response = await newURL.post(`wasteanalytics`, requestBody, {
        params: queryParams,
        headers: { "Content-Type": "application/json" },
      });
      const data = response.data;
      this.setState({
        incoming: data.incomingTotal,
        unsorted: data.unsortedTotal,
        sorted: data.sortedTotal,
        outgoing: data.outgoingTotal,
        showLoader: false,
      });
      const rawBackendLabels = data.graph?.labels || [];
      const backendData = data.graph?.data || [];

      let fullLabels: string[] = [];
      let alignedData: number[] = [];

      // If backend sent monthly labels (YYYY-MM or "Mon YYYY")
      if (
        /^\d{4}-\d{2}$/.test(rawBackendLabels[0]) ||
        /^[A-Za-z]{3} \d{4}$/.test(rawBackendLabels[0])
      ) {
        // Format monthly labels as "Mon YYYY"
        fullLabels = rawBackendLabels.map((label: any) =>
          new Date(label + "-01").toLocaleDateString("en-US", {
            month: "short",
            year: "numeric",
          })
        );
        alignedData = backendData;
      } else {
        const labelStart = new Date(queryParams.startDate);
        const labelEnd = new Date(queryParams.endDate);
        // const fullLabels: string[] = [];
        const cursor = new Date(labelStart);
        while (cursor <= labelEnd) {
          fullLabels.push(
            cursor.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })
          );
          cursor.setDate(cursor.getDate() + 1);
        }
        // const rawBackendLabels = data.graph?.labels || [];
        const backendLabels = rawBackendLabels.map((dateStr: string) =>
          new Date(dateStr).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          })
        );
        // const backendData = data.graph?.data || [];
        const dataMap: Record<string, number> = {};
        backendLabels.forEach((label: string, idx: number) => {
          dataMap[label] = backendData[idx];
        });
        alignedData = fullLabels.map((label) => dataMap[label] || 0);
      }

      this.setState({
        weightReportDataBar: {
          labels: fullLabels,
          datasets: [
            {
              label: "kg",
              data: alignedData,
              // backgroundColor: 'rgba(0, 176, 172, 1)',
              backgroundColor: "rgba(32, 77, 54, 0.5)",
              borderWidth: 2,
              borderColor: "rgba(32, 77, 54, 1)",
            },
          ],
        },
      });
    } catch (error) {
      console.error("Error fetching waste analytics:", error);
      this.setState({ showLoader: false });
    }
  };
  public fetchVehicles() {
    axios
      .get(`getListOfVehicles`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let data: any = response.data.data;
        this.setState({ vehicles: data });
      });
  }

  public fetchAgentsAll(page: number = 0, limit: number = this.state.pageSize) {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let options = {
        hierarchies: this.props.user.selectedHierarchyIds,
        filter: "",
        page: page + 1,
        limit: limit,
      };
      axios
        .post(`allAgentsV2`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let data: any = response.data.data.data;
          let agents: any = [];
          data.map((agent: any) => {
            agents.push({
              id: agent.id,
              agent_name: agent.name,
              mobile: agent.phone,
              email: agent.email,
              type_id: agent.agent_type,
            });
          });

          console.log(agents);

          this.setState({ agents: agents });
        })
        .catch((error) => {
          this.setState({
            showLoader: false,
          });
          toast.error(error.response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  }
  public fetchAgents() {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let options = { hierarchies: this.props.user.selectedHierarchyIds };
      axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
        this.setState({ showLoader: false });
        let sorting_agents: any = response.data.data;
        this.setState({ sorting_agents: sorting_agents });
      });
    }
  }

  public fetchMaterialTypesAll() {
    axios
      .get(`getTypeOfIncomingWaste`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let vehicleDensityMapped: any = {};
        let data: any = response.data.data;
        for (const obj of data) {
          vehicleDensityMapped[obj.id] = obj.density;
          console.log(obj);
        }
        this.setState({
          materialTypes: data,
          vehicleDensityMapped: vehicleDensityMapped,
        });
        console.log(this.state.materialTypes);
      });
  }

  public fetchMaterialTypes() {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let options = { hierarchies: this.props.user.selectedHierarchyIds };
      axios
        .get(`subTypesOfMaterial`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let material_types: any = response.data.data;
          this.setState({ material_types: material_types });
          this.fetchMaterialTypesRaw();
        });
    }
  }

  public fetchMaterialTypesRaw() {
    if (this.props.user.selectedHierarchyIds.length) {
      this.setState({ showLoader: true });
      let material_types = this.state.material_types;
      let options = { hierarchies: this.props.user.selectedHierarchyIds };
      axios
        .get(`getSortedWasteForStorageType`, { params: options })
        .then((response: any) => {
          this.setState({ showLoader: false });
          let data: any = response.data.data;
          let unit = this.state.units[0]?.id;
          let material_types_raw: any = {};
          let i = 0;
          Object.keys(data).map(function (key) {
            let item = data[key];
            let subValue: any = {};
            (material_types[item] || []).map((subItem: any, key: number) => {
              subValue[key] = {
                typeOfSortedWaste: item,
                subTypesOfMaterialEntry: subItem.id,
                unit: unit,
              };
            });
            material_types_raw[i] = {};
            material_types_raw[i]["SubVal"] = subValue;
            i++;
          });
          this.setState({ material_types_raw: material_types_raw });
        });
    }
  }

  public fetchUnits() {
    axios
      .get(`getUnits`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
      })
      .then((response) => {
        let data: any = response.data.data;
        this.setState({ units: data });
      });
  }

  public resetVehicleWaste() {
    this.setState({
      date: "",
      agent_id: "",
      vehicle: "",
      depatureTime: "",
      arrivalTime: "",
      depatureKM: 0,
      arrivalKM: 0,
      material_type: "",
      route_id: "",
      total_incoming_waste_percentage: 0,
      total_hangar_percentage: 0,
      total_container_percentage: 0,
      total_container_waste_kg: 0,
      total_incoming_waste_kg: 0,
      total_hangar_waste_kg: 0,
      total_incoming_waste_volume: 0,
      total_hangar_waste_volume: 0,
      total_container_volume: 0,
      error: true,
      errorMessage: "",
      showAddByVehicleSubmitButton: true,
      vehicleDateTimeError: true,
      vehiclDriverError: true,
      vehicleFleetIdError: true,
      vehicleScheduleError: true,
      vehicleClusterError: true,
      vehicleIncomingWasteError: true,
      vehicleHangarError: true,
      vehicleContainerError: true,
      ValueWrongError: true,
      ValueWrongErrorMsg: "",
    });
  }

  public checkForValueValidation() {
    const language = localStorage.getItem("language");
    let num1 = parseInt(this.state.total_hangar_percentage);
    let num2 = parseInt(this.state.total_container_percentage);
    let num3 = parseInt(this.state.total_incoming_waste_percentage);

    console.log(num1);
    console.log(num2);
    console.log(num3);

    if (num1 + num2 != num3) {
      if (language != null && language == "IDN") {
        this.setState({
          error: true,
          ValueWrongError: true,
          ValueWrongErrorMsg: "Periksa kembali angka % yang dimasukan",
        });
      } else {
        this.setState({
          error: true,
          ValueWrongError: true,
          ValueWrongErrorMsg: "Please check the % number",
        });
      }
    } else {
      this.setState({
        error: false,
        ValueWrongError: false,
        ValueWrongErrorMsg: "",
      });
    }
  }

  public isNotNullAndNotEmpty(value: any) {
    return value !== null && value !== "";
  }

  public checkForValidation() {
    const language = localStorage.getItem("language");

    if (this.isNotNullAndNotEmpty(this.state.date) == true) {
      this.setState({ vehicleDateTimeError: false });
    }
    if (this.isNotNullAndNotEmpty(this.state.agent_id) == true) {
      this.setState({ vehiclDriverError: false });
    }
    if (this.isNotNullAndNotEmpty(this.state.vehicle) == true) {
      this.setState({ vehicleFleetIdError: false });
    }
    if (this.isNotNullAndNotEmpty(this.state.material_type) == true) {
      this.setState({ vehicleScheduleError: false });
    }
    if (this.isNotNullAndNotEmpty(this.state.route_id) == true) {
      this.setState({ vehicleClusterError: false });
    }

    let num1 = parseInt(this.state.total_hangar_percentage);
    let num2 = parseInt(this.state.total_container_percentage);
    let num3 = parseInt(this.state.total_incoming_waste_percentage);

    if (
      this.state.vehicleDateTimeError == true ||
      this.state.vehiclDriverError == true ||
      this.state.vehicleFleetIdError == true ||
      this.state.vehicleScheduleError == true ||
      this.state.vehicleClusterError == true
    ) {
      if (language != null && language == "IDN") {
        this.setState({
          error: true,
          errorMessage: "Isi semua data yang dibutuhkan ditandai dengan",
        });
      } else {
        this.setState({
          error: true,
          errorMessage: "Please fill all required data (*)",
        });
      }
    } else {
      if ((num1 != 0 || num2 != 0 || num3 != 0) && num1 + num2 == num3) {
        this.setState({ error: false, errorMessage: "" });
      } else {
        if (language != null && language == "IDN") {
          this.setState({
            error: true,
            errorMessage: "Isi semua data yang dibutuhkan ditandai dengan",
          });
        } else {
          this.setState({
            error: true,
            errorMessage: "Please fill all required data (*)",
          });
        }
      }
    }
  }

  public hideButtons() {
    const accessiblehierarchies = this.props.user.selectedHierarchyIds;
    const argentineHierarchies = [2, 4, 7, 13, 14, 16, 17, 19];
    const mergedHierarchies = [
      ...accessiblehierarchies,
      ...argentineHierarchies,
    ];
    const uniqueIds = Array.from(new Set(mergedHierarchies));
    const nonArgentineids = uniqueIds.filter(
      (item) => !argentineHierarchies.includes(item)
    );
    if (nonArgentineids.length != 0) {
      this.setState({ hideAddIncomingWasteByVehicleBtn: false });
    }
  }

  public render() {
    if (!localStorage.getItem("token")) {
      return <Redirect to="/login" />;
    }
    const { t } = this.props;

    const handleExportExpenses = () => {
      if (this.state.fromDate && this.state.toDate) {
        let url = "/DownloadInventory/";
        if (axios.defaults.baseURL) {
          let currentBaseURL: string = axios.defaults.baseURL;
          currentBaseURL = currentBaseURL.split("/").slice(0, 3).join("/");
          url = currentBaseURL + url;
        }
        window.open(
          url +
            formatDate(this.state.fromDate, "Y-m-d") +
            "/" +
            formatDate(this.state.toDate, "Y-m-d") +
            "/" +
            this.props.user.selectedHierarchyIds
        );
      }
    };

    const handleMaterialFlowDurationChange = (duration: string) => {
      this.setState({ materialFlowDuration: duration });
      if (duration == "custom") {
        this.setState({
          showCustomDateFilter: true,
          durationType: "materialFlow",
        });
      } else {
        this.fetchMaterialFlowReporting(duration);
      }
    };
    const formatNumber = (value: number) => {
      if (value == null) return "-";
      // Split whole and decimal
      const parts = value.toString().split(".");
      // Add commas only to whole part
      const whole = Number(parts[0]).toLocaleString("en-IN"); // Indian style grouping
      return parts.length > 1 ? `${whole}.${parts[1]}` : whole;
    };

    const handleDiversionPerformanceDurationChange = (duration: string) => {
      this.setState({ diversionPerformanceDuration: duration });
      if (duration == "custom") {
        this.setState({
          showCustomDateFilter: true,
          durationType: "diversionPerformance",
        });
      } else {
        this.fetchDiversionPerformance(duration);
      }
    };
    const handleDateFilterChange = (filter: string) => {
      let labels: any = [];
      const today = new Date();
      if (filter === "today") {
        labels = Array.from({ length: 24 }, (_, i) => `${i}:00`);
      } else if (filter === "week") {
        labels = Array.from({ length: 7 }, (_, i) => {
          const d = new Date();
          d.setDate(today.getDate() - 6 + i);
          return d.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        });
      } else if (filter === "month") {
        const daysInMonth = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        ).getDate();
        labels = Array.from({ length: daysInMonth }, (_, i) => {
          const d = new Date(today.getFullYear(), today.getMonth(), i + 1);
          return d.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        });
      } else if (filter === "lastMonth") {
        const prevMonth = today.getMonth() === 0 ? 11 : today.getMonth() - 1;
        const year =
          prevMonth === 11 ? today.getFullYear() - 1 : today.getFullYear();
        const daysInPrevMonth = new Date(year, prevMonth + 1, 0).getDate();
        labels = Array.from({ length: daysInPrevMonth }, (_, i) => {
          const d = new Date(year, prevMonth, i + 1);
          return d.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        });
      }
      if (filter === "custom") {
        this.setState({
          selectedDateFilter: filter,
          showCustomDateFilter: true,
          customFromDate: null,
          customToDate: null,
          weightReportDataBar: {
            ...this.state.weightReportDataBar,
            labels: [],
          },
        });
      } else {
        this.setState(
          {
            selectedDateFilter: filter,
            weightReportDataBar: { ...this.state.weightReportDataBar, labels },
          },
          () => {
            this.fetchWasteAnalytics();
            this.fetchWasteAnalyticsTableData();
          }
        );
      }
    };
    const handleAddWasteByVehicle = (event: any) => {
      event.preventDefault();
      let datetime: any = this.state.date
        ? formatDate(this.state.date, "Y-m-d") +
          " " +
          (this.state.time ? formatTime(this.state.time, "H:i:s") : "00:00:00")
        : "";

      let arrivalTimeDate = new Date(this.state.arrivalTime);
      let depatureTimeDate = new Date(this.state.depatureTime);

      let arrivalTimeUTC = arrivalTimeDate.toUTCString();
      let depatureTimeUTC = depatureTimeDate.toUTCString();

      let data: any = {
        route: this.state.routes[this.state.route_id],
        datetime: datetime,
        typesOfVehicles: this.state.vehicle,
        depatureTime: depatureTimeUTC,
        arrivalTime: arrivalTimeUTC,
        depatureKM: this.state.depatureKM,
        arrivalKM: this.state.arrivalKM,
        material_type: this.state.material_type,
        total_incoming_waste_percentage:
          this.state.total_incoming_waste_percentage,
        total_incoming_waste_kg: this.state.total_incoming_waste_kg,
        total_hangar_percentage: this.state.total_hangar_percentage,
        total_hangar_waste_kg: this.state.total_hangar_waste_kg,
        total_container_percentage: this.state.total_container_percentage,
        total_container_waste_kg: this.state.total_container_waste_kg,
        sorted_agent_id: this.state.agent_id,
        total_incoming_waste_volume: this.state.total_incoming_waste_volume,
        total_hangar_waste_volume: this.state.total_hangar_waste_volume,
        total_container_volume: this.state.total_container_volume,
        editUUID: this.state.editUUID,
      };
      newURL
        .post(`addIncomingWasteByVehicleV2`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.status === 200) {
            this.setState({
              showAddWasteByVehicle: false,
              editVehicle: false,
              source: "",
              time: null,
              percent_full: 0,
              total_waste: 0,
              recyclables_percentage: 0,
              recyclables_kg: 0,
              organics_percentage: 0,
              organics_kg: 0,
              residual_percentage: 0,
              residual_kg: 0,
              showLoader: false,
              editUUID: "",
              date: "",
              agent_id: "",
              vehicle: "",
              depatureTime: "",
              arrivalTime: "",
              depatureKM: 0,
              arrivalKM: 0,
              material_type: "",
              route_id: "",
              total_incoming_waste_percentage: 0,
              total_hangar_percentage: 0,
              total_container_percentage: 0,
              total_container_waste_kg: 0,
              total_incoming_waste_kg: 0,
              total_hangar_waste_kg: 0,
              total_incoming_waste_volume: 0,
              total_hangar_waste_volume: 0,
              total_container_volume: 0,
              error: true,
              errorMessage: "",
              showAddByVehicleSubmitButton: true,
              vehicleDateTimeError: true,
              vehiclDriverError: true,
              vehicleFleetIdError: true,
              vehicleScheduleError: true,
              vehicleClusterError: true,
              vehicleIncomingWasteError: true,
              vehicleHangarError: true,
              vehicleContainerError: true,
              ValueWrongError: true,
              ValueWrongErrorMsg: "",
            });
            toast.success("Incoming Waste Added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchMaterialFlowReporting();
          } else {
            this.setState({
              showAddWasteByVehicle: false,
              editVehicle: false,
              source: "",
              time: null,
              percent_full: 0,
              total_waste: 0,
              recyclables_percentage: 0,
              recyclables_kg: 0,
              organics_percentage: 0,
              organics_kg: 0,
              residual_percentage: 0,
              residual_kg: 0,
              showLoader: false,
              editUUID: "",
              date: "",
              agent_id: "",
              vehicle: "",
              depatureTime: "",
              arrivalTime: "",
              depatureKM: 0,
              arrivalKM: 0,
              material_type: "",
              route_id: "",
              total_incoming_waste_percentage: 0,
              total_hangar_percentage: 0,
              total_container_percentage: 0,
              total_container_waste_kg: 0,
              total_incoming_waste_kg: 0,
              total_hangar_waste_kg: 0,
              total_incoming_waste_volume: 0,
              total_hangar_waste_volume: 0,
              total_container_volume: 0,
              error: true,
              errorMessage: "",
              showAddByVehicleSubmitButton: true,
              vehicleDateTimeError: true,
              vehiclDriverError: true,
              vehicleFleetIdError: true,
              vehicleScheduleError: true,
              vehicleClusterError: true,
              vehicleIncomingWasteError: true,
              vehicleHangarError: true,
              vehicleContainerError: true,
              ValueWrongError: true,
              ValueWrongErrorMsg: "",
            });
            toast.error("Incoming Waste Was Not Added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error: any) => {
          this.setState({
            showAddWasteByVehicle: false,
            editVehicle: false,
            source: "",
            time: null,
            percent_full: 0,
            total_waste: 0,
            recyclables_percentage: 0,
            recyclables_kg: 0,
            organics_percentage: 0,
            organics_kg: 0,
            residual_percentage: 0,
            residual_kg: 0,
            showLoader: false,
            editUUID: "",
            date: "",
            agent_id: "",
            vehicle: "",
            depatureTime: "",
            arrivalTime: "",
            depatureKM: 0,
            arrivalKM: 0,
            material_type: "",
            route_id: "",
            total_incoming_waste_percentage: 0,
            total_hangar_percentage: 0,
            total_container_percentage: 0,
            total_container_waste_kg: 0,
            total_incoming_waste_kg: 0,
            total_hangar_waste_kg: 0,
            total_incoming_waste_volume: 0,
            total_hangar_waste_volume: 0,
            total_container_volume: 0,
            error: true,
            errorMessage: "",
            showAddByVehicleSubmitButton: true,
            vehicleDateTimeError: true,
            vehiclDriverError: true,
            vehicleFleetIdError: true,
            vehicleScheduleError: true,
            vehicleClusterError: true,
            vehicleIncomingWasteError: true,
            vehicleHangarError: true,
            vehicleContainerError: true,
            ValueWrongError: true,
            ValueWrongErrorMsg: "",
          });

          //   if(language != null && language == "IDN"){
          //     toast.error("Unexpected Error Incoming Waste Not Added", {
          //     position: "top-right",
          //     autoClose: 3000,
          //     hideProgressBar: true,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     theme: "colored",
          // });

          //   }
        });
    };

    const handleAddIncomingWasteByMassUpload = (event: any) => {
      event.preventDefault();
      this.setState({ showLoader: true });
      let datetime: any = this.state.datetime
        ? formatDate(this.state.datetime, "Y-m-d H:i:s")
        : "";
      let data: any = {
        Mapping: this.state.routesRaw,
        Routes: this.state.massUploadData,
        datetime: datetime,
      };
      axios
        .post(`addIncomingWasteMassUpload`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({
              showAddIncomingWasteByMassUpload: false,
              massUploadData: {},
              datetime: null,
              showLoader: false,
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchMaterialFlowReporting();
          } else {
            this.setState({
              showAddIncomingWasteByMassUpload: false,
              massUploadData: {},
              datetime: null,
              showLoader: false,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showAddIncomingWasteByMassUpload: false,
            massUploadData: {},
            datetime: null,
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleIncomingMassUploadDataChange = (
      route_key: any,
      material_type: string,
      kg: any
    ) => {
      let massUploadData = this.state.massUploadData;
      if (massUploadData[route_key]) {
        massUploadData[route_key][material_type] = kg ? kg : null;
      } else {
        let item: any = {};
        item[material_type] = kg ? kg : null;
        massUploadData[route_key] = item;
      }
    };

    const handleAddDivertedWasteByMassUpload = (event: any) => {
      event.preventDefault();
      this.setState({ showLoader: true });
      let datetime: any = this.state.datetime
        ? formatDate(this.state.datetime, "Y-m-d H:i:s")
        : "";
      let data: any = {
        Val: this.state.material_types_raw,
        sorted_agent_id: this.state.agent_id,
        route: this.state.routes[this.state.route_id],
        datetime: datetime,
        unit: this.state.units[0].id,
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      axios
        .post(`addUpdateMassUploadSortedWaste`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({
              showAddDivertedWasteByMassUpload: false,
              agent_id: "",
              route_id: "",
              datetime: null,
              showLoader: false,
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchMaterialFlowReporting();
          } else {
            this.setState({
              showAddDivertedWasteByMassUpload: false,
              agent_id: "",
              route_id: "",
              datetime: null,
              showLoader: false,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showAddDivertedWasteByMassUpload: false,
            agent_id: "",
            route_id: "",
            datetime: null,
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleDivertedMassUploadDataChange = (
      key: number,
      subKey: number,
      fieldName: string,
      value: any
    ) => {
      let massUploadData = this.state.material_types_raw;
      if (massUploadData[key]) {
        massUploadData[key]["SubVal"][subKey][fieldName] = value ? value : null;
      }
      this.setState({ material_types_raw: massUploadData });
    };

    return (
      <div>
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
          open={this.state.showLoader}
          // onClick={() => this.setState({ showLoader: false })}
        >
          <CircularProgress className="customLoader" />
        </Backdrop>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
<DiversionHeader user={this.props.user} />
        {/* <Grid container spacing={2}> */}
        {/* <Grid item md={12} xs={12} className="mt-3"> */}
        {/* <Card> */}
        {/* <CardHeader
                                title={t("Overview")}
                                className="text-left"
                                sx={{ paddingBottom: '0px' }}
                            /> */}
        {/* <CardContent sx={{ paddingTop: '0px' }}> */}
        {/* <CardActions> */}
        {/* <Button variant='contained' className='link' component={Link} to={'/incoming-waste-charts'}>{t("ViewIncomingWaste")}</Button>
                                    <Button variant='contained' className='link' component={Link} to={'/diverted-waste-charts'}>{t("ViewDivertedWaste")}</Button>
                                    <Button variant='contained' className='link' component={Link} to={'/outgoing-waste-charts'}>{t("ViewOutgoingWaste")}</Button> */}
        {/* {
                                        (!this.state.hideAddIncomingWasteByVehicleBtn) &&
                                        <Button variant="contained" sx={{ outline: "none !important" }} onClick={() => this.setState({ showAddIncomingWasteByVehicle: true,showAddWasteByVehicle:true })}>{t("Quick Add") + ' - ' + t("Incoming By Vehicle")}</Button>
                                    }
                                    <Button variant="contained" sx={{ outline: "none !important" }} onClick={() => this.setState({ showAddIncomingWasteByMassUpload: true })}>{t("Quick Add") + ' - ' + t("Incoming Mass Upload")}</Button>
                                    <Button variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddDivertedWasteByMassUpload: true })}>{t("Quick Add") + ' - ' + t("Diverted Mass Upload")}</Button> */}
        {/* </CardActions> */}
        {/* <Grid container spacing={2}> */}
        {/* <Grid item md={12} xs={12}> */}
        {/* <Card sx={{ boxShadow: 3 }} className="materialFlowReporting"> */}
        <CardHeader
          // title={t("Material Flow Reporting")}
          className="text-left"
          sx={{ paddingTop: "0px", paddingBottom: "0px" }}
          action={
            <CardActions>
              {/* <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                            <Select
                                                                // variant="standard"
                                                                size='small'
                                                                value={this.state.materialFlowDuration}
                                                                onChange={(e) => handleMaterialFlowDurationChange(e.target.value)}
                                                                displayEmpty
                                                                className='durationSelection'
                                                            >
                                                                <MenuItem value={'today'}>{t("Today")}</MenuItem>
                                                                <MenuItem value={'week'}>1 {t("Week")}</MenuItem>
                                                                <MenuItem value={'month'}>1 {t("Month")}</MenuItem>
                                                                <MenuItem value={'3 months'}>3 {t("Months")}</MenuItem>
                                                                <MenuItem value={'custom'}>{t("Custom")}</MenuItem>
                                                            </Select>
                                                        </FormControl> */}
              {/* <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                            <Select
                                                                // variant="standard"
                                                                size='small'
                                                                value={this.state.wasteType}
                                                                onChange={(e) => { this.setState({ wasteType: e.target.value }); this.fetchMaterialFlowReporting(this.state.materialFlowDuration, e.target.value); }}
                                                                displayEmpty
                                                                className='summaryOfWaste'
                                                            >
                                                                <MenuItem value={''}>{t("Summary Of Waste")}</MenuItem>
                                                                <MenuItem value={'recyclingOnly'}>{t("Recyclables Only")}</MenuItem>
                                                                <MenuItem value={'organicsOnly'}>{t("Organics Only")}</MenuItem>
                                                            </Select>
                                                        </FormControl> */}
              {/* <ButtonGroup variant="contained" className="diversionButtonGroup" aria-label="Material Flow of Diverted Waste button group"> */}
              {/* <Button className={(this.state.materialFlowDuration == 'today') ? "active" : ""} onClick={() => handleMaterialFlowDurationChange('today')}>{t("Today")}</Button> */}
              {/* <Button className={(this.state.materialFlowDuration == 'week') ? "active" : ""} onClick={() => handleMaterialFlowDurationChange('week')}>{t("Week")}</Button>
                                                            <Button className={(this.state.materialFlowDuration == 'month') ? "active" : ""} onClick={() => handleMaterialFlowDurationChange('month')}>{t("Last Month")}</Button>
                                                            <Button className={(this.state.materialFlowDuration == 'custom') ? "active" : ""} onClick={() => handleMaterialFlowDurationChange('custom')}>{t("Custom")}</Button> */}
              {/* </ButtonGroup> */}
            </CardActions>
          }
        />
        {/* <CardContent sx={{ paddingTop: '0px' }}> */}
        {/* <Grid container spacing={2}> */}
        {/* <Grid item md={12} xs={12}> */}
        {/* <Bar data={this.state?.incomingWasteDataBar} options={this.state.incomingWasteBarChartOptions} height={200} redraw={true} /> */}
        {/* <Button variant='contained' className='link mt-2' component={Link} to={'/incoming-waste-charts'}>{t("Incoming Waste Details")}</Button> */}
        {/* </Grid> */}
        {/* <Grid item md={4} xs={12}>
                                                        <Bar data={this.state.divertedWasteDataBar} options={this.state.divertedWasteBarChartOptions} height={300} redraw={true} />
                                                        <Button variant='contained' className='link mt-2' component={Link} to={'/diverted-waste-charts'}>{t("Diverted Waste Details")}</Button>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <Bar data={this.state.outgoingWasteDataBar} options={this.state.outgoingWasteBarChartOptions} height={300} redraw={true} />
                                                        <Button variant='contained' className='link mt-2' component={Link} to={'/outgoing-waste-charts'}>{t("Outgoing Waste Details")}</Button>
                                                    </Grid> */}
        {/* </Grid> */}
        {/* </CardContent> */}
        {/* </Card> */}
        {/* </Grid> */}
        {/* <Grid item md={6} xs={12}>
                                        <Card sx={{ boxShadow: 3 }} className="diversionPerformance">
                                            <CardHeader
                                                title={t("Diversion Performance")}
                                                className="text-left"
                                                action={<Select
                                                    // variant="standard"
                                                    size='small'
                                                    value={this.state.diversionPerformanceDuration}
                                                    onChange={(e) => handleDiversionPerformanceDurationChange(e.target.value)}
                                                    displayEmpty
                                                    className='durationSelection'
                                                >
                                                    <MenuItem value={'today'}>{t("Today")}</MenuItem>
                                                    <MenuItem value={'week'}>1 {t("Week")}</MenuItem>
                                                    <MenuItem value={'month'}>1 {t("Month")}</MenuItem>
                                                    <MenuItem value={'custom'}>{t("Custom")}</MenuItem>
                                                </Select>
                                                }
                                            />
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={12} xs={12}>
                                                        <Bar data={this.state.diversionPerformanceDataBar} options={this.state.diversionPerformanceBarChartOptions} height={250} redraw={true} />
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid> */}
        {/* <Grid item md={6} xs={12}>
                                        <Card sx={{ boxShadow: 3 }} className="diversionPerformance">
                                            <CardHeader
                                                title={t("Inventory In Hand")}
                                                className="text-left"
                                                action={
                                                    <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showExportExpenses: true })}>
                                                        {t("Export Expense List")}
                                                    </Button>
                                                }
                                            />
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={12} xs={12}>
                                                        <Bar data={this.state.inventoryInHandDataBar} options={this.state.inventoryInHandBarChartOptions} height={250} redraw={true} />
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid> */}
        {/* </Grid> */}
        {/* </CardContent> */}
        {/* </Card> */}
        {/* </Grid> */}
        {/* </Grid> */}
        <Card sx={{ height: "100%" }}>
          {/* <CardHeader
                    title={t("WeightReport")}
                    className="text-left"
                    sx={{ paddingBottom: '0px' }}
                /> */}

          <CardContent sx={{ pt: 2, pb: 0 }}>
            <Grid container spacing={2}>
              <Grid item md={2.2} xs={12} className="text-center">
                <Card
                  sx={{
                    justifyContent: "center",
                    display: "flex",
                    boxShadow: 3,
                  }}
                >
                  <CardContent className="overview">
                    <Typography
                      variant="h6"
                      component="div"
                      className="overviewTitle"
                    >
                      Incoming{" "}
                      <Tooltip
                        placement="top"
                        title="Total incoming waste for the selected time period"
                        arrow
                      >
                        <Box
                          component="span"
                          // sx={{ fontSize: "0.6em", fontWeight: 500 }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 16,
                            height: 16,
                            fontSize: "0.65em",
                            fontWeight: 600,
                            backgroundColor: "#006400",
                            color: "white",
                            borderRadius: "50%",
                            boxShadow: 1,
                            border: "1px solid",
                            borderColor: "primary.light",
                          }}
                        >
                          i
                        </Box>
                      </Tooltip>
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      className="overviewValue"
                    >
                      {this.state.incoming}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={2.2} xs={12} className="text-center">
                <Card
                  sx={{
                    justifyContent: "center",
                    display: "flex",
                    boxShadow: 3,
                  }}
                >
                  <CardContent className="overview">
                    <Typography
                      variant="h6"
                      component="div"
                      className="overviewTitle"
                    >
                      Sorted{" "}
                      <Tooltip
                        placement="top"
                        title="Total  daily level sorted for selected time period"
                        arrow
                      >
                        <Box
                          component="span"
                          // sx={{ fontSize: "0.6em", fontWeight: 500 }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 16,
                            height: 16,
                            fontSize: "0.65em",
                            fontWeight: 600,
                            backgroundColor: "#006400",
                            color: "white",
                            borderRadius: "50%",
                            boxShadow: 1,
                            border: "1px solid",
                            borderColor: "primary.light",
                          }}
                        >
                          i
                        </Box>
                      </Tooltip>
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      className="overviewValue"
                    >
                      {this.state.sorted}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={2.2} xs={12} className="text-center">
                <Card
                  sx={{
                    justifyContent: "center",
                    display: "flex",
                    boxShadow: 3,
                  }}
                >
                  <CardContent className="overview">
                    <Typography
                      variant="h6"
                      component="div"
                      className="overviewTitle"
                    >
                      UnSorted{" "}
                      <Tooltip
                        placement="top"
                        title="Incoming-Sorted-Reject"
                        arrow
                      >
                        <Box
                          component="span"
                          // sx={{ fontSize: "0.6em", fontWeight: 500 }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 16,
                            height: 16,
                            fontSize: "0.65em",
                            fontWeight: 600,
                            backgroundColor: "#006400",
                            color: "white",
                            borderRadius: "50%",
                            boxShadow: 1,
                            border: "1px solid",
                            borderColor: "primary.light",
                          }}
                        >
                          i
                        </Box>
                      </Tooltip>
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      className="overviewValue statusTextSuccess"
                    >
                      {this.state.unsorted}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={2.2} xs={12} className="text-center">
                <Card
                  sx={{
                    justifyContent: "center",
                    display: "flex",
                    boxShadow: 3,
                  }}
                >
                  <CardContent className="overview">
                    <Typography
                      variant="h6"
                      component="div"
                      className="overviewTitle"
                    >
                      Outgoing{" "}
                      <Tooltip
                        placement="top"
                        title="Total outgoing waste for the selected time period"
                        arrow
                      >
                        <Box
                          component="span"
                          // sx={{ fontSize: "0.6em", fontWeight: 500 }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 16,
                            height: 16,
                            fontSize: "0.65em",
                            fontWeight: 600,
                            backgroundColor: "#006400",
                            color: "white",
                            borderRadius: "50%",
                            boxShadow: 1,
                            border: "1px solid",
                            borderColor: "primary.light",
                          }}
                        >
                          i
                        </Box>
                      </Tooltip>
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      className="overviewValue statusTextError"
                    >
                      {this.state.outgoing}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={2.5} xs={12} className="text-center">
                <Card
                  sx={{
                    justifyContent: "center",
                    display: "flex",
                    boxShadow: 3,
                  }}
                >
                  <CardContent className="overview">
                    <Typography
                      variant="h6"
                      component="div"
                      className="overviewTitle"
                    >
                      Current inventory{""}
                      <Tooltip
                        placement="top"
                        title="Total material at warehouse"
                        arrow
                      >
                        <Box
                          component="span"
                          // sx={{ fontSize: "0.6em", fontWeight: 500 }}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 16,
                            height: 16,
                            fontSize: "0.65em",
                            fontWeight: 600,
                            backgroundColor: "#006400",
                            color: "white",
                            borderRadius: "50%",
                            boxShadow: 1,
                            border: "1px solid",
                            borderColor: "primary.light",
                          }}
                        >
                          i
                        </Box>
                      </Tooltip>
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      className="overviewValue"
                    >
                      {this.state.inventoryTotal ?? 0}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>

          {/* Dropdown just below the title */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 3,
              mt: 4,
            }}
          >
            {/* Left: Waste Type Dropdown */}
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="waste-type-label">
                {t("Select Waste Type")}
              </InputLabel>
              <Select
                labelId="waste-type-label"
                value={this.state.selectedWasteType}
                label={t("Select Waste Type")}
                onChange={(e) =>
                  this.setState(
                    { selectedWasteType: e.target.value },
                    this.fetchWasteAnalytics
                  )
                }
              >
                <MenuItem value="incoming">{t("Incoming Waste")}</MenuItem>
                <MenuItem value="sorted">{t("Sorted Waste")}</MenuItem>
                <MenuItem value="outgoing">{t("Outgoing Waste")}</MenuItem>
              </Select>
            </FormControl>

            {/* Right: Date Filter Buttons */}
            <ButtonGroup variant="contained" size="small">
              <Button
                color={
                  this.state.selectedDateFilter === "today"
                    ? "inherit"
                    : "primary"
                }
                onClick={() => handleDateFilterChange("today")}
              >
                Today
              </Button>
              <Button
                color={
                  this.state.selectedDateFilter === "week"
                    ? "inherit"
                    : "primary"
                }
                onClick={() => handleDateFilterChange("week")}
              >
                Week
              </Button>
              <Button
                color={
                  this.state.selectedDateFilter === "month"
                    ? "inherit"
                    : "primary"
                }
                onClick={() => handleDateFilterChange("month")}
              >
                Current Month
              </Button>
              <Button
                color={
                  this.state.selectedDateFilter === "lastMonth"
                    ? "inherit"
                    : "primary"
                }
                onClick={() => handleDateFilterChange("lastMonth")}
              >
                Last Month
              </Button>
              <Button
                color={
                  this.state.selectedDateFilter === "custom"
                    ? "inherit"
                    : "primary"
                }
                onClick={() => handleDateFilterChange("custom")}
              >
                Custom
              </Button>
            </ButtonGroup>
          </Box>

          {/* Chart Section */}
          <CardContent>
            <Box>
              <CardContent sx={{ pt: 1, pl: 0, pr: 0 }}>
                {this.state.selectedWasteType === "incoming" && (
                  <Bar
                    data={this.state.weightReportDataBar}
                    options={this.state.weightReportBarChartOptions}
                    height={120}
                  />
                )}
                {this.state.selectedWasteType === "sorted" && (
                  <Bar
                    data={this.state.weightReportDataBar}
                    options={this.state.weightReportBarChartOptions}
                    height={120}
                  />
                )}
                {this.state.selectedWasteType === "outgoing" && (
                  <Bar
                    data={this.state.weightReportDataBar}
                    options={this.state.weightReportBarChartOptions}
                    height={120}
                  />
                )}
              </CardContent>
            </Box>
          </CardContent>
          <Box sx={{ width: "100%", maxWidth: 1100, mx: "auto", mt: 0 }}>
            {/* Chart Component */}

            {/* Summary Table */}
            <TableContainer
              component={Paper}
              sx={{ width: "100%", boxShadow: 3, mt: 0, mb: 3 }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ background: "#274226" }}>
                    <TableCell
                      align="center"
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      Summary
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      Incoming(Kgs)
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      Sorted(Kgs)
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      Reject Waste(Kgs)
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      Outgoing(Kgs)
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#fff", fontWeight: "bold" }}
                    >
                      Outgoing Value (INR)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Render total summary row */}
                  <TableRow>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                      Total
                    </TableCell>
                    <TableCell align="center">
                      {formatNumber(Number(this.state.incoming.toFixed(2)))}
                    </TableCell>
                    <TableCell align="center">
                      {formatNumber(Number(this.state.sorted.toFixed(2)))}
                    </TableCell>
                    <TableCell align="center">
                      {formatNumber(Number(this.state.reject.toFixed(2)))}
                    </TableCell>
                    <TableCell align="center">
                      {formatNumber(Number(this.state.outgoing.toFixed(2)))}
                    </TableCell>
                    <TableCell align="center">
                      ₹
                      {formatNumber(
                        Number(this.state.dailyAnalyticsData.reduce(
                          (acc, val) => acc + val.outgoingValueINR,
                          0
                        ).toFixed(2))
                      )}
                    </TableCell>
                  </TableRow>

                  {/* Render dynamic rows from API data */}
                  {this.state.dailyAnalyticsData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{item.date}</TableCell>
                      <TableCell align="center">
                        {formatNumber(item.incoming)}
                      </TableCell>
                      <TableCell align="center">
                        {formatNumber(item.sorted)}
                      </TableCell>
                      <TableCell align="center">
                        {formatNumber(item.reject)}
                      </TableCell>
                      <TableCell align="center">
                        {formatNumber(item.outgoing)}
                      </TableCell>
                      <TableCell align="center">
                        ₹{formatNumber(item.outgoingValueINR)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Card>

        <Modal
          open={this.state.showCustomDateFilter}
          onClose={() => this.setState({ showCustomDateFilter: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Select Custom Analytics Dates")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showCustomDateFilter: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("From Date") + " *"}
                          value={this.state.customFromDate}
                          onChange={(newValue: any) => {
                            this.setState({ customFromDate: newValue });
                          }}
                          minDate={new Date(2025, 3, 1)}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("To Date") + " *"}
                          value={this.state.customToDate}
                          onChange={(newValue: any) => {
                            this.setState({ customToDate: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showCustomDateFilter: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  disabled={
                    !this.state.customFromDate || !this.state.customToDate
                  }
                  // onClick={() => {this.fetchMaterialFlowReporting(); this.setState({showCustomDateFilter: false});this.fetchWasteAnalytics();
                  //  }}
                  onClick={() => {
                    this.setState(
                      {
                        selectedDateFilter: "custom",
                        showCustomDateFilter: false,
                      },
                      () => {
                        this.fetchWasteAnalytics();
                        this.fetchWasteAnalyticsTableData();
                        this.fetchMaterialFlowReporting();
                      }
                    );
                  }}
                >
                  {t("Get Analytics")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showExportExpenses}
          onClose={() => this.setState({ showExportExpenses: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title={t("Export Data")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showExportExpenses: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("From Date") + " *"}
                          value={this.state.fromDate}
                          onChange={(newValue: any) => {
                            this.setState({ fromDate: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("To Date") + " *"}
                          value={this.state.toDate}
                          onChange={(newValue: any) => {
                            this.setState({ toDate: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showExportExpenses: false })}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                  disabled={!this.state.fromDate || !this.state.toDate}
                  onClick={() => handleExportExpenses()}
                >
                  {t("Export")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddWasteByVehicle || this.state.editVehicle}
          onClose={() => {
            this.setState({ showAddWasteByVehicle: false, editVehicle: false });
            this.resetVehicleWaste();
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card
              component={"form"}
              onSubmit={(event: any) => handleAddWasteByVehicle(event)}
            >
              <CardHeader
                title={t("Add Waste By Vehicle")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({
                        showAddWasteByVehicle: false,
                        editVehicle: false,
                      })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Date" + "*")}
                          value={this.state.date}
                          onChange={(newValue: any) => {
                            this.setState({ date: newValue }, () => {
                              this.checkForValidation();
                            });
                          }}
                          disableFuture={true}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="sorting-agent-select-label">
                        {t("Driver")} *
                      </InputLabel>
                      <Select
                        labelId="sorting-agent-select-label"
                        value={this.state.agent_id}
                        onChange={(e) => {
                          console.log(this.state.agent_id);
                          this.setState({ agent_id: e.target.value }, () => {
                            this.checkForValidation();
                          });
                        }}
                        displayEmpty
                        label={t("Sorting Agent") + " *"}
                        fullWidth={true}
                      >
                        {this.state.agents.map((sorting_agent: any) => {
                          return (
                            <MenuItem
                              key={sorting_agent.id}
                              value={sorting_agent.id}
                            >
                              {sorting_agent.agent_name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="vehicles-select-label">
                        {t("Fleet ID")}
                      </InputLabel>
                      <Select
                        labelId="vehicles-select-label"
                        value={this.state.vehicle}
                        onChange={(e) => {
                          this.setState(
                            {
                              vehicle: e.target.value,
                              vehicle_capacity:
                                this.state.vehiclesMapped[e.target.value],
                            },
                            () => {
                              this.checkForValidation();
                            }
                          );
                        }}
                        displayEmpty
                        label={t("Vehicle")}
                        fullWidth={true}
                      >
                        {this.state.vehicles.map((vehicle) => {
                          return (
                            <MenuItem key={vehicle.id} value={vehicle.id}>
                              {vehicle.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          inputFormat="hh:mm a"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Depature Time")}
                          value={this.state.depatureTime}
                          onChange={(newValue: any) => {
                            this.setState({ depatureTime: newValue }, () => {
                              this.checkForValidation();
                            });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>

                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <TimePicker
                          inputFormat="hh:mm a"
                          renderInput={(props) => <TextField {...props} />}
                          label={t("Arrival Time")}
                          value={this.state.arrivalTime}
                          onChange={(newValue: any) => {
                            this.setState({ arrivalTime: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      id="vehicle-capacity-input"
                      label={t("Depature KM")}
                      value={this.state.depatureKM}
                      onChange={(e) =>
                        this.setState(
                          { depatureKM: Number.parseInt(e.target.value) },
                          () => {
                            this.checkForValidation();
                          }
                        )
                      }
                      type="number"
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      id="vehicle-capacity-input"
                      label={t("Arrival KM")}
                      value={this.state.arrivalKM}
                      onChange={(e) =>
                        this.setState(
                          { arrivalKM: Number.parseInt(e.target.value) },
                          () => {
                            this.checkForValidation();
                          }
                        )
                      }
                      type="number"
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="material-types-select-label">
                        {t("Material Type" + "*")}
                      </InputLabel>
                      <Select
                        labelId="material-types-select-label"
                        value={this.state.material_type}
                        onChange={(e) => {
                          this.setState(
                            {
                              material_type: e.target.value,
                              vehicle_density:
                                this.state.vehicleDensityMapped[e.target.value],
                            },
                            () => {
                              this.checkForValidation();
                            }
                          );
                        }}
                        displayEmpty
                        label={t("Material Type")}
                        fullWidth={true}
                        required
                      >
                        {this.state.materialTypes.map(
                          (materialType: any, key: any) => {
                            return (
                              <MenuItem key={key} value={materialType.id}>
                                {materialType.name}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="routes-select-label">
                        {t("Route" + "*")}
                      </InputLabel>
                      <Select
                        labelId="routes-select-label"
                        value={this.state.route_id}
                        onChange={(e) => {
                          this.setState({ route_id: e.target.value }, () => {
                            this.checkForValidation();
                          });
                        }}
                        displayEmpty
                        label={t("Route")}
                        fullWidth={true}
                        required
                      >
                        {this.state.routes.map((route, key) => {
                          if (route.type == "hierarchy") {
                            return (
                              <MenuItem key={key} value={key} disabled={true}>
                                {route.route}
                              </MenuItem>
                            );
                          } else if (route.type == "multiple_routes") {
                            return (
                              <MenuItem key={key} value={key}>
                                &nbsp;&nbsp;{route.route}
                              </MenuItem>
                            );
                          } else {
                            return (
                              <MenuItem key={key} value={key}>
                                &nbsp;&nbsp;{route.route}
                              </MenuItem>
                            );
                          }
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="percent-full-input"
                      label={t("% Of Incoming Waste")}
                      value={this.state.total_incoming_waste_percentage}
                      type="number"
                      InputProps={{
                        inputProps: { min: 0, max: 100000000 },
                      }}
                      onChange={(e: any) => {
                        this.setState(
                          {
                            total_incoming_waste_percentage: e.target.value,
                            total_incoming_waste_kg:
                              ((this.state.vehicle_capacity * e.target.value) /
                                100) *
                              this.state.vehicle_density,
                            total_incoming_waste_volume:
                              (this.state.vehicle_capacity * e.target.value) /
                              100,
                          },
                          () => {
                            this.checkForValueValidation();
                          }
                        );
                      }}
                      fullWidth={true}
                      required
                    />
                  </Grid>
                  <Grid item md={4} xs={8}>
                    <TextField
                      id="recyclables-percent"
                      label={t("% In Hangar")}
                      value={this.state.total_hangar_percentage}
                      type="number"
                      InputProps={{
                        inputProps: { min: 0, max: 100000000 },
                      }}
                      onChange={(e: any) => {
                        this.setState(
                          {
                            total_hangar_percentage: e.target.value,
                            total_hangar_waste_kg:
                              ((e.target.value * this.state.vehicle_capacity) /
                                100) *
                              this.state.vehicle_density,
                            total_hangar_waste_volume:
                              (e.target.value * this.state.vehicle_capacity) /
                              100,
                          },
                          () => {
                            this.checkForValueValidation();
                          }
                        );
                      }}
                      fullWidth={true}
                      required
                    />
                  </Grid>
                  <Grid item md={4} xs={8}>
                    <TextField
                      id="organics-percent"
                      label={t("% In Container")}
                      value={this.state.total_container_percentage}
                      type="number"
                      InputProps={{
                        inputProps: { min: 0, max: 100000000 },
                      }}
                      onChange={(e: any) => {
                        this.setState(
                          {
                            total_container_percentage: e.target.value,
                            total_container_waste_kg:
                              ((e.target.value * this.state.vehicle_capacity) /
                                100) *
                              this.state.vehicle_density,
                            total_container_volume:
                              (e.target.value * this.state.vehicle_capacity) /
                              100,
                          },
                          () => {
                            this.checkForValueValidation();
                          }
                        );
                      }}
                      fullWidth={true}
                      required
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{ flexGrow: 1 }}
                    >
                      Volume Incoming {this.state.total_incoming_waste_volume}{" "}
                      m3
                    </Typography>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{ flexGrow: 1 }}
                    >
                      Volume In Hangar {this.state.total_hangar_waste_volume} m3
                    </Typography>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{ flexGrow: 1 }}
                    >
                      Volume In Container {this.state.total_container_volume} m3
                    </Typography>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-left">
                {this.state.error && (
                  <Typography variant="subtitle1" gutterBottom>
                    {this.state.errorMessage}
                  </Typography>
                )}

                {this.state.ValueWrongError && (
                  <Typography variant="subtitle1" gutterBottom>
                    {this.state.ValueWrongErrorMsg}
                  </Typography>
                )}
              </CardActions>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => {
                    this.setState({
                      showAddWasteByVehicle: false,
                      editVehicle: false,
                    });
                    this.resetVehicleWaste();
                  }}
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                >
                  {t("Add Waste")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddIncomingWasteByMassUpload}
          onClose={() =>
            this.setState({ showAddIncomingWasteByMassUpload: false })
          }
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card
              component={"form"}
              onSubmit={(event: any) =>
                handleAddIncomingWasteByMassUpload(event)
              }
            >
              <CardHeader
                title={t("Add Waste By Mass Upload")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showAddIncomingWasteByMassUpload: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <CardActions className="mb-3">
                  <FormControl>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        inputFormat="yyyy-MM-dd HH:mm"
                        renderInput={(props) => <TextField {...props} />}
                        label={t("Date Time")}
                        value={this.state.datetime}
                        onChange={(newValue: any) => {
                          this.setState({ datetime: newValue });
                        }}
                        disableFuture={true}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </CardActions>
                <Divider className="mb-3" />
                <Grid container>
                  <Grid item md={12} xs={12}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        boxShadow: 3,
                        height: "400px !important",
                        overflowY: "scroll",
                      }}
                    >
                      <Table sx={{ minWidth: 600 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Community Name")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Mixed Dry Waste")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Wet Waste")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Reject Waste")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Others")}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.routesRaw.map(
                            (route: any, key: number) => {
                              return (
                                <TableRow key={route.id}>
                                  <TableCell>{route.name}</TableCell>
                                  <TableCell>
                                    <TextField
                                      id="mixed-recyclables-kg-input"
                                      label={t("Mixed Dry Waste In KG")}
                                      type="number"
                                      onChange={(e: any) =>
                                        handleIncomingMassUploadDataChange(
                                          key,
                                          "mixed_dry_waste",
                                          e.target.value
                                        )
                                      }
                                      fullWidth={true}
                                      size="small"
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      id="mixed-organics-kg-input"
                                      label={t("Wet Waste In KG")}
                                      type="number"
                                      onChange={(e: any) =>
                                        handleIncomingMassUploadDataChange(
                                          key,
                                          "wet_waste",
                                          e.target.value
                                        )
                                      }
                                      fullWidth={true}
                                      size="small"
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      id="residual-kg-input"
                                      label={t("Reject Waste In KG")}
                                      type="number"
                                      onChange={(e: any) =>
                                        handleIncomingMassUploadDataChange(
                                          key,
                                          "reject_waste",
                                          e.target.value
                                        )
                                      }
                                      fullWidth={true}
                                      size="small"
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      id="residual-kg-input"
                                      label={t("Others In KG")}
                                      type="number"
                                      onChange={(e: any) =>
                                        handleIncomingMassUploadDataChange(
                                          key,
                                          "others",
                                          e.target.value
                                        )
                                      }
                                      fullWidth={true}
                                      size="small"
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() =>
                    this.setState({ showAddIncomingWasteByMassUpload: false })
                  }
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                >
                  {t("Add Waste")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showAddDivertedWasteByMassUpload}
          onClose={() =>
            this.setState({ showAddDivertedWasteByMassUpload: false })
          }
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card
              component={"form"}
              onSubmit={(event: any) =>
                handleAddDivertedWasteByMassUpload(event)
              }
            >
              <CardHeader
                title={t("Add Waste By Mass Upload")}
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showAddDivertedWasteByMassUpload: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <CardActions className="mb-3">
                  <FormControl fullWidth={true}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        inputFormat="yyyy-MM-dd HH:mm"
                        renderInput={(props) => <TextField {...props} />}
                        label={t("Date Time") + " *"}
                        value={this.state.datetime}
                        onChange={(newValue: any) => {
                          this.setState({ datetime: newValue });
                        }}
                        disableFuture={true}
                      />
                    </LocalizationProvider>
                  </FormControl>
                  <FormControl fullWidth={true}>
                    <InputLabel id="routes-select-label">
                      {t("Community")} *
                    </InputLabel>
                    <Select
                      labelId="routes-select-label"
                      value={this.state.route_id}
                      onChange={(e) =>
                        this.setState({ route_id: e.target.value })
                      }
                      displayEmpty
                      label={t("Community") + " *"}
                      fullWidth={true}
                    >
                      {this.state.routes.map((route) => {
                        return (
                          <MenuItem key={route.id} value={route.id}>
                            {route.route}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth={true}>
                    <InputLabel id="sorting-agent-select-label">
                      {t("Sorting Agent")} *
                    </InputLabel>
                    <Select
                      labelId="sorting-agent-select-label"
                      value={this.state.agent_id}
                      onChange={(e) =>
                        this.setState({ agent_id: e.target.value })
                      }
                      displayEmpty
                      label={t("Sorting Agent") + " *"}
                      fullWidth={true}
                    >
                      {this.state.sorting_agents.map((sorting_agent) => {
                        return (
                          <MenuItem
                            key={sorting_agent.id}
                            value={sorting_agent.id}
                          >
                            {sorting_agent.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </CardActions>
                <Divider className="mb-3" />
                <Grid container>
                  <Grid item md={12} xs={12}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        boxShadow: 3,
                        height: "400px !important",
                        overflowY: "scroll",
                      }}
                    >
                      <Table sx={{ minWidth: 600 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Waste Type")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Waste Sub Type")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Weight")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Unit")}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="subtitle1" component="div">
                                {t("Comments")}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.keys(this.state.material_types).map(
                            (item: any, key: number) => {
                              let types: any = this.state.material_types[item];
                              return types.map((type: any, subKey: number) => {
                                return (
                                  <TableRow key={type.id}>
                                    <TableCell
                                      sx={{ width: "15%" }}
                                      size="small"
                                    >
                                      {type.material}
                                    </TableCell>
                                    <TableCell
                                      sx={{ width: "25%" }}
                                      size="small"
                                    >
                                      {type.name}
                                    </TableCell>
                                    <TableCell
                                      sx={{ width: "20%" }}
                                      size="small"
                                    >
                                      <TextField
                                        id="weight-input"
                                        label={t("Weight")}
                                        type="number"
                                        value={
                                          this.state.material_types_raw[key]
                                            ? this.state.material_types_raw[
                                                key
                                              ]["SubVal"][subKey]["quantity"]
                                            : ""
                                        }
                                        onChange={(e: any) =>
                                          handleDivertedMassUploadDataChange(
                                            key,
                                            subKey,
                                            "quantity",
                                            e.target.value
                                          )
                                        }
                                        fullWidth={true}
                                        InputProps={{
                                          inputProps: { min: 0 },
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell
                                      sx={{ width: "15%" }}
                                      size="small"
                                    >
                                      <FormControl fullWidth={true}>
                                        <InputLabel id="unit-label">
                                          {t("Unit")}
                                        </InputLabel>
                                        <Select
                                          labelId="unit-label"
                                          value={
                                            this.state.material_types_raw[key]
                                              ? this.state.material_types_raw[
                                                  key
                                                ]["SubVal"][subKey]["unit"]
                                              : ""
                                          }
                                          onChange={(e: any) =>
                                            handleDivertedMassUploadDataChange(
                                              key,
                                              subKey,
                                              "unit",
                                              e.target.value
                                            )
                                          }
                                          displayEmpty
                                          label={t("Unit")}
                                          fullWidth={true}
                                        >
                                          {this.state.units.map((unit) => {
                                            return (
                                              <MenuItem
                                                key={unit.id}
                                                value={unit.id}
                                              >
                                                {unit.name}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      </FormControl>
                                    </TableCell>
                                    <TableCell
                                      sx={{ width: "25%" }}
                                      size="small"
                                    >
                                      <TextField
                                        id="comments-input"
                                        label={t("Comments")}
                                        value={
                                          this.state.material_types_raw[key]
                                            ? this.state.material_types_raw[
                                                key
                                              ]["SubVal"][subKey]["description"]
                                            : ""
                                        }
                                        onChange={(e: any) =>
                                          handleDivertedMassUploadDataChange(
                                            key,
                                            subKey,
                                            "description",
                                            e.target.value
                                          )
                                        }
                                        fullWidth={true}
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              });
                            }
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() =>
                    this.setState({ showAddDivertedWasteByMassUpload: false })
                  }
                >
                  {t("Close")}
                </Button>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  sx={{ outline: "none !important" }}
                >
                  {t("Add Waste")}
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
      </div>
    );
  }
}

export default withRouter(withTranslation()(Diversion));
